/* global fbq:readonly, fbAjax:readonly */

/* eslint-disable */
function fbBase(pixelId) {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq)f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js'));
  fbq('init', pixelId);
  fbq('track', 'PageView');
}

function fbTrack(kind, content_name, currency, value) {
  fbq('track', kind, {
    content_name,
    currency,
    value,
  });
}
/* eslint-enable */

if (typeof fbAjax !== 'undefined') {
  const pixelId = (typeof fbAjax.pixelId === 'undefined')
    ? ''
    : fbAjax.pixelId;
  const viewContentContentName = (typeof fbAjax.viewContentContentName === 'undefined')
    ? ''
    : fbAjax.viewContentContentName;
  const viewContentCurrencyCode = (typeof fbAjax.viewContentCurrencyCode === 'undefined')
    ? ''
    : fbAjax.viewContentCurrencyCode;
  const viewContentValue = (typeof fbAjax.viewContentValue === 'undefined')
    ? ''
    : fbAjax.viewContentValue;
  const completeRegistrationContentName = (typeof fbAjax.completeRegistrationContentName === 'undefined')
    ? ''
    : fbAjax.completeRegistrationContentName;
  const completeRegistrationCurrencyCode = (typeof fbAjax.completeRegistrationCurrencyCode === 'undefined')
    ? ''
    : fbAjax.completeRegistrationCurrencyCode;
  const completeRegistrationValue = (typeof fbAjax.completeRegistrationValue === 'undefined')
    ? ''
    : fbAjax.completeRegistrationValue;

  // console.log(`facebook.js - facebook stuff
  //    crcn ${completeRegistrationContentName}
  //    crcc ${completeRegistrationCurrencyCode}
  //    crv ${completeRegistrationValue}
  //    vccn ${viewContentContentName}
  //    vccc ${viewContentCurrencyCode}
  //    vcv ${viewContentValue}
  //    pixelId ${pixelId}
  //  `);

  if (pixelId !== '') {
    fbBase(pixelId);
  }

  if (
    viewContentContentName !== ''
    && viewContentCurrencyCode !== ''
    && viewContentValue !== ''
  ) {
    fbTrack(
      'viewContent',
      viewContentContentName,
      viewContentCurrencyCode,
      viewContentValue,
    );
  }

  if (
    completeRegistrationContentName !== ''
    && completeRegistrationCurrencyCode !== ''
    && completeRegistrationValue !== ''
  ) {
    fbTrack(
      'CompleteRegistration',
      completeRegistrationContentName,
      completeRegistrationCurrencyCode,
      completeRegistrationValue,
    );
  }
}

export {
  fbBase,
  fbTrack,
};
